<!-- eslint-disable vue/no-v-html -->
<template>
  <BlFlexContainerMv class="edu-karier-page-article" direction="column" padding="8px 16px">
    <div class="edu-karier-page-article__article" :class="{expanded: isExpanded}">
      <article v-html="sanitizeContent" />
      <FAQContent :faqs="EDU_KARIER_META.faqs" />
    </div>
    <center class="mb-32">
      <BlLinkAv variation="primary" @click="onToggleEllipsis">
        <template v-if="isExpanded">
          Sembunyikan
          <IcoChevronUpMinor class="pt-8" color="#2B4AC7" />
        </template>
        <template v-else>
          Selengkapnya
          <IcoChevronDownMinor class="pt-8" color="#2B4AC7" />
        </template>
      </BlLinkAv>
    </center>
  </BlFlexContainerMv>
</template>

<script>
import {BlFlexContainerMv, BlLinkAv} from '@bukalapak/bazaar-mweb-latest';
import {IcoChevronDownMinor, IcoChevronUpMinor} from '@bukalapak/bazaar-visual-next';
import EDU_KARIER_META from '../../../../../config/meta/edu-karier';

const FAQContent = () => import(/* webpackPrefetch: true */ /* webpackChunkName: "FAQContent" */ './FAQContent.vue');

export default {
  name: 'PageArticle',
  components: {
    BlLinkAv,
    BlFlexContainerMv,
    IcoChevronDownMinor,
    IcoChevronUpMinor,
    FAQContent,
  },
  data: () => ({
    isExpanded: false,
    EDU_KARIER_META,
  }),
  computed: {
    sanitizeContent() {
      return this.EDU_KARIER_META.article
        .replace(/bl-text--body-16/g, 'bl-text--caption-12')
        .replace(/bl-text--subheading-18/g, 'bl-text--caption-12 bl-text--bold')
        .replace(/bl-text--subheading-20/g, 'bl-text--caption-14 bl-text--bold')
        .replace(/bl-text--heading-28/g, 'bl-text--body-16 bl-text--bold')
        .replace(/mb-20 mt-32/g, 'mv-20');
    },
  },
  methods: {
    onToggleEllipsis() {
      this.isExpanded = !this.isExpanded;
    },
  },
};
</script>

<style lang="scss" scoped>
.edu-karier-page-article {
  &__article {
    &:not(.expanded) {
      overflow: hidden;
      height: 260px;
    }
  }
}
</style>
